import { useState } from 'react';
import styled from 'styled-components';
import { FiSend } from 'react-icons/fi'; // Poderia adicionar FaMicrophone depois
import { FaSmile } from 'react-icons/fa'; // Ícone de emoji

const InputContainer = styled.form`
  display: flex;
  align-items: center;
  gap: 0.8rem;
  background: #202c33; /* Fundo da barra inferior dark */
  padding: 0.6rem 1rem;
`;

const InputWrapper = styled.div`
  flex: 1;
  display: flex;
  align-items: center;
  background: #2a3942; /* Fundo do input dark */
  border-radius: 0.5rem; /* Bordas menos arredondadas */
  padding: 0.5rem 1rem;
`;


const Input = styled.input`
  flex: 1;
  background: transparent;
  border: none;
  color: #e9edef; /* Texto claro */
  font-size: 1rem;
  outline: none;
  margin-left: 0.5rem;
`;

const IconButton = styled.button`
  background: none;
  border: none;
  color: #8696a0; /* Cor ícones dark */
  font-size: 1.5rem;
  cursor: pointer;
  padding: 0.3rem;
  display: flex;
  align-items: center;
  justify-content: center;
`;


const SendButton = styled.button`
  background: #00a884; /* Manter verde WhatsApp */
  border: none;
  color: #fff; /* Manter texto branco */
  border-radius: 50%;
  width: 44px;
  height: 44px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  transition: background 0.2s;
  &:hover {
    background: #008a6e; /* Verde mais escuro no hover */
  }
  &:disabled {
    background: #b0c4b1; /* Cor quando desabilitado */
    cursor: default;
  }
`;

export default function ChatInput({ onSend, loading }) {
  const [value, setValue] = useState('');
  const handleSubmit = (e) => {
    e.preventDefault();
    if (value.trim() && !loading) {
      onSend(value);
      setValue('');
    }
  };
  return (
    <InputContainer onSubmit={handleSubmit}>
      {/* Adicionar ícones opcionais como emoji/anexo aqui depois */}
      <InputWrapper>
        <IconButton type="button" aria-label="Emojis">
          <FaSmile />
        </IconButton>
        <Input
          type="text"
          placeholder="Digite uma mensagem" /* Placeholder mais direto */
        value={value}
        onChange={e => setValue(e.target.value)}
        disabled={loading}
        aria-label="Digite sua mensagem"
      />
      </InputWrapper> {/* Adicionar tag de fechamento que faltava */}
      <SendButton type="submit" disabled={loading || !value.trim()} aria-label="Enviar mensagem">
        <FiSend size={22} />
      </SendButton>
    </InputContainer>
  );
}
